module.exports = __webpack_public_path__ + "img/set-more.3223f5d8.png";